const Center = () => import('@/views/moving/Center')
const Index = () => import('@/views/moving/Index')
export default [{
  path: '/moving',
  meta: {
    title: '智能割草',
    activeMenu: '/home/board'
  },
  components: {
    default: Center,
    right: Index
  }
}]
